import { mapState } from 'vuex';

export default {
  name: 'functionsWithUser',
  data() {
    return {
      selectedUsers: [],
    };
  },
  computed: {
    ...mapState({
      contacts: (state) => state.user.userContacts,
      user: (state) => state.user.user,
    }),
  },
  methods: {
    selectUser(user) {
      const index = this.selectedUsers.findIndex((selectedUser) => selectedUser.uid === user.uid);
      if (index === -1) {
        this.selectedUsers.push(user);
      } else {
        this.selectedUsers.splice(index, 1);
      }
    },
  },
};
